import request from "@/common/request";

export const goAgentChat = async (agent: {
  type?: number;
  flow_id: string | number;
  uuid: string;
  tag: string;
  flow_type?: number;
  ver?: string;
  team_id?: string;
}) => {
  const response = await request.get('/user/info');
  const userInfo = response?.data || {};
  const bind_qid = userInfo?.id || '';
  if (agent.flow_type === 1) {
    // @ts-ignore - Vite 
    const flowPath = import.meta.env.VITE_APP_FLOW_AGENT_EDIT_PATH || '';
    window.location.href = `${flowPath}?qid=${bind_qid}&flow_version=${agent.ver}&flow_id=${agent.flow_id}&teamId=${agent.team_id}&agent_ver=${agent.tag}&agent_uuid=${agent.uuid}`
  } else{
    // @ts-ignore - Vite 
    const agentPath = import.meta.env.VITE_AGENT_CHAT_PATH || '';
    window.location.href = `${agentPath}/${agent?.type === 6 ? agent?.flow_id : agent?.uuid}?agent_ver=${agent?.tag || agent?.ver}&agent_uuid=${agent?.uuid}`;

  }
};

export const goAgentCreate = () => {
  window.location.href = `https://saas.360.cn/nano-ai-saas?create=1`;
};
